import { DirectReport } from './_constants';
import { customAlphabet } from 'nanoid';
import { cloneDeep } from 'lodash';

/**
 * Retrieve a report's assignment(s).
 *
 * @param {DirectReport} report direct report to evaluate.
 * @param {DirectReport[]} reports array of reports to evaluate.
 * @returns {DirectReport[]} array of report assignment(s).
 */
export const getReportAssignments = (report, reports) =>
	reports.filter(r => r.id === report.id);

/**
 * Filters array of direct reports to those missing a job category assignment.
 *
 * @param {DirectReport[]} reports array of reports to evaluate.
 * @returns {DirectReport[]} array of reports missing a job category assignment.
 */
export const getUnmappedReports = reports =>
	reports.filter(report => report.assignment?.jobCategory?.id === -1);

/**
 * Custom nano ID generator that excludes numeric characters.
 * @function
 */
export const nanoid = customAlphabet(
	'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz',
	21
);

/**
 * Re-integrates a staffer's assignments into a staff assignment snapshot.
 * 
 * @param {DirectReport[]} arrStaffer array of staffer's assignments.
 * @param {DirectReport[]} arrSnapshot staff assignments to be synced.
 * @returns {DirectReport[]} copy of staff assignments, re-synced.
 */
export const syncSnapshot = (arrStaffer, arrSnapshot) => {
	const stafferID = arrStaffer[0]?.id;
	const indexStaffer = arrSnapshot.findIndex(report => report.id === stafferID);
	// remove edited staffer from snapshot
	const arrSnapshotCopy = cloneDeep(
		arrSnapshot.filter(report => report.id !== stafferID)
	);
	// attempt to re-add edited staffer to snapshot while loosely preserving page location
	if (indexStaffer > -1) {
		arrSnapshotCopy.splice(indexStaffer, 0, ...cloneDeep(arrStaffer));
	} else {
		arrSnapshotCopy.push(...cloneDeep(arrStaffer));
	}

	return arrSnapshotCopy;
}